import { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useNewColorSchemaOptions from 'utils/hooks/useNewColorSchemaOptions';

const CondoOptions = ({ fields }) => {
  // Fields
  const colorCode = getFieldValue(fields, 'colorCode'); // "#dee7d7"; "#333"; //
  const textColor = getFieldValue(fields, 'textColor'); // "#dee7d7"; fff white 000 black "#fff"; //
  const textColorCode = textColor === 'white-text' ? '#fff' : '#000'; // "#dee7d7"; fff white 000 black; //
  const useColor = getFieldValue(fields, 'useColor'); // true; //
  // console.log({ fields, textColor, textColorCode, colorCode });
  const {
    updateNewSchemaColorCode,
    updateNewSchemaTextColorCode,
    updateShowNewSchemaColor,
  } = useNewColorSchemaOptions();

  useEffect(() => {
    if (useColor) {
      updateShowNewSchemaColor(useColor);
      updateNewSchemaColorCode(colorCode);
      updateNewSchemaTextColorCode(textColorCode);
    } else {
      updateShowNewSchemaColor(false);
      updateNewSchemaColorCode('');
      updateNewSchemaTextColorCode('');
    }
  }, [useColor]);

  return '';
};

export default CondoOptions;
